import * as actionTypes from "../actionTypes";
import * as eventTypes from "../eventTypes";
import initialState from "../../../../../../reducers/initialState";

export default function reducer(state = initialState.currentOffer.paymentPlanData, action) {
  const initialPaymentPlanData = initialState.currentOffer.paymentPlanData;

  switch (action.type) {
    case actionTypes.LOAD_OFFER_PAYMENT_PLAN_SUCCESS: {
      return {
        ...state,
        paymentPlan: action.payload.paymentPlan,
        isComputed: true,
        isLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_PAYMENT_PLAN_SUMMARY_SUCCESS: {
      return {
        ...state,
        paymentPlanSummary: action.payload.paymentPlanSummary,
        summaryLoaded: true
      };
    }

    case eventTypes.OFFER_PAYMENT_PLAN_INVALIDATED: {
      return {
        ...state,
        isLoaded: false
      };
    }

    case eventTypes.OFFER_PAYMENT_PLAN_SUMMARY_INVALIDATED: {
      return {
        ...state,
        summaryLoaded: false
      };
    }

    case eventTypes.OFFER_PAYMENT_PLAN_COMPUTED: {
      return {
        ...state,
        paymentPlan: initialPaymentPlanData.paymentPlan,
        isComputed: true,
        isLoaded: false
      };
    }

    case actionTypes.LOAD_OFFER_PAYMENT_PLAN_FAILED: {
      return initialPaymentPlanData;
    }

    case actionTypes.LOAD_OFFER_PAYMENT_PLAN_SUMMARY_FAILED: {
      return initialPaymentPlanData;
    }

    case actionTypes.LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED: {
      return {
        ...state,
        scheduleCellParams: {
          ...state.scheduleCellParams,
          loading: true
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS: {
      return {
        ...state,
        scheduleCellParams: Object.assign({}, action.payload.scheduleCellParams, {
          isLoaded: true,
          loading: false,
          saving: false
        })
      };
    }

    case actionTypes.LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_STARTED: {
      return {
        ...state,
        scheduleTypeCellParamTemplates: {
          ...state.scheduleTypeCellParamTemplates,
          loading: true,
          isLoaded: false
        }
      };
    }

    case actionTypes.LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_FAILED: {
      return {
        ...state,
        scheduleTypeCellParamTemplates: {
          ...state.scheduleTypeCellParamTemplates,
          loading: false,
          isLoaded: false
        }
      };
    }

    case actionTypes.LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_SUCCESS: {
      return {
        ...state,
        scheduleTypeCellParamTemplates: Object.assign(
          {},
          { data: action.payload.scheduleTypeCellParamTemplates, isLoaded: true, loading: false, saving: false }
        )
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED: {
      return {
        ...state,
        scheduleCellParams: initialPaymentPlanData.scheduleCellParams
      };
    }

    case actionTypes.LOAD_SCHEDULE_PARAMS_TYPE_SUCCESS: {
      return {
        ...state,
        scheduleTypeParams: {
          ...state.scheduleTypeParams,
          typeParams: action.payload.scheduleTypeParams,
          isLoaded: true
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCHEDULE_PARAMS_STARTED: {
      return {
        ...state,
        documentScheduleParams: {
          ...state.documentScheduleParams,
          isLoaded: false,
          loading: true
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_SCHEDULE_PARAMS_SUCCESS: {
      const { documentScheduleParams } = action.payload;
      return {
        ...state,
        documentScheduleParams: {
          ...state.documentScheduleParams,
          isLoaded: true,
          loading: false,
          paramList: documentScheduleParams
        }
      };
    }
    case actionTypes.LOAD_DOCUMENT_SCHEDULE_PARAMS_FAILED: {
      return {
        ...state,
        documentScheduleParams: {
          ...state.documentScheduleParams,
          isLoaded: false,
          loading: false
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_PARAMS_STARTED: {
      const { documentId, siteId, documentScheduleParams } = action.payload;
      return {
        ...state,
        documentScheduleParams: {
          ...state.documentScheduleParams,
          documentId,
          siteId,
          saving: true,
          saved: false,
          paramList: documentScheduleParams
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_PARAMS_SUCCESS: {
      const { documentId, siteId, documentScheduleParams } = action.payload;
      return {
        ...state,
        documentScheduleParams: {
          ...state.documentScheduleParams,
          documentId,
          siteId,
          saving: false,
          saved: true,
          paramList: documentScheduleParams
        },
        isLoaded: false
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_PARAMS_FAILED: {
      return {
        ...state,
        documentScheduleParams: {
          saving: false,
          saved: false
        }
      };
    }

    case actionTypes.DOCUMENT_SCHEDULE_PARAMS_INVALIDATED: {
      return {
        ...state,
        documentScheduleParams: {
          isLoaded: false
        }
      };
    }

    case eventTypes.DOCUMENT_SCHEDULE_CELL_PARAM_INVALIDATED: {
      return {
        ...state,
        scheduleCellParams: initialPaymentPlanData.scheduleCellParams
      };
    }

    case eventTypes.SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_INVALIDATED: {
      return {
        ...state,
        scheduleTypeCellParamTemplates: initialPaymentPlanData.scheduleTypeCellParamTemplates
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED: {
      return {
        ...state,
        scheduleCellParams: {
          ...state.scheduleCellParams,
          values: Object.assign([...action.payload.scheduleCellParams]),
          isLoaded: true,
          saving: true
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS: {
      return {
        ...state,
        scheduleCellParams: {
          ...state.scheduleCellParams,
          values: Object.assign([...action.payload.scheduleCellParams]),
          isLoaded: true,
          saving: false
        }
      };
    }

    case actionTypes.SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED: {
      return {
        ...state,

        scheduleCellParams: {
          ...state.scheduleCellParams,
          values: Object.assign([...action.payload.scheduleCellParams]),
          isLoaded: true,
          saving: false
        }
      };
    }

    default:
      return state;
  }
}
